export var NotificationType;

(function (NotificationType) {
  NotificationType["Warning"] = "warning";
  NotificationType["Error"] = "error";
  NotificationType["Info"] = "info";
  NotificationType["Success"] = "success";
})(NotificationType || (NotificationType = {}));


//////////////////
// WEBPACK FOOTER
// ./node_modules/@shazambanking/sdk/services/notifications/types.js
// module id = 255
// module chunks = 0